export default __webpack_public_path__ + "static/media/videocase2.ae37ead0.png";